{
  "title": "Billing",
  "description": "Manage your subscription and ad campaign payments.",
  "tabs": {
    "subscription": "Subscription",
    "adCampaigns": "Ad Campaigns"
  },
  "subscription": {
    "price": "Price",
    "expires": "Expires",
    "plan": "plan",
    "statusActive": "Active",
    "statusPending": "Pending Payment",
    "completePayment": "Complete payment",
    "starting": "Starting…",
    "upgradeToPremium": "Upgrade to Premium",
    "upgrading": "Upgrading…",
    "activated": "Premium subscription activated",
    "paymentProcessing": "Payment is processing. Refresh shortly if features stay locked.",
    "payError": "Failed to start payment",
    "upgradeSuccess": "Upgraded to Premium. Complete payment to activate.",
    "upgradeError": "Failed to upgrade",
    "couldNotStart": "Could not start payment"
  },
  "adCampaigns": {
    "empty": "No ad campaigns yet.",
    "create": "Create campaign",
    "viewAll": "View all campaigns"
  }
}
